import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Async } from '@/shared/ui/Async';
import { Button } from '@/shared/ui/Button';

import { RequestCard } from '../components/RequestCard';
import { useMyRequests } from '../hooks/use-coverage';

/** The masjid_admin's own coverage requests. */
export function MyRequestsRoute(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const query = useMyRequests();

  return (
    <main className="page stack">
      <div className="row row--between">
        <h1>{t('nav.requests')}</h1>
        <Button onClick={() => navigate('/requests/create')}>{t('coverage.create')}</Button>
      </div>
      <Async query={query} isEmpty={(l) => l.length === 0} emptyMessage={t('coverage.emptyMine')}>
        {(requests) => (
          <div className="stack">
            {requests.map((request) => (
              <RequestCard
                key={request.id}
                request={request}
                onOpen={() => navigate(`/requests/${request.id}`)}
              />
            ))}
          </div>
        )}
      </Async>
    </main>
  );
}
